import { createConfigOption, optionalWithDefault, partialWithDefault, struct } from "./config-option";

const assetActionConfig = struct({
  frozen: optionalWithDefault(createConfigOption<boolean>())(false),
});

export type AssetConfig = ReturnType<(typeof assetConfig)["create"]>;
export type AssetConfigAction = keyof AssetConfig["actions"];

export const assetConfig = struct({
  name: optionalWithDefault(createConfigOption<string | undefined>())(undefined),
  symbol: optionalWithDefault(createConfigOption<string | undefined>())(undefined),
  frozen: optionalWithDefault(createConfigOption<boolean>())(false),
  actions: optionalWithDefault(
    partialWithDefault(
      struct({
        deposit: assetActionConfig,
        withdraw: assetActionConfig,
        borrow: assetActionConfig,
        repay: assetActionConfig,
      })
    )({
      deposit: assetActionConfig.create({}),
      withdraw: assetActionConfig.create({}),
      borrow: assetActionConfig.create({}),
      repay: assetActionConfig.create({}),
    })
  )({}),
  disabledCollateral: optionalWithDefault(createConfigOption<DisabledCollateralConfig | undefined>())(undefined),
});

interface DisabledCollateralConfig {
  description: string;
  link: string;
}
